import { Circle, Line } from './styles';

export const Crossmark = () => (
  <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1">
    <Circle cx="20" cy="20" r="18" />
    <Line delay={250} x1="15" y1="15" x2="25" y2="25" />
    <Line delay={350} x1="25" y1="15" x2="15" y2="25" />
  </svg>
);
